import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.scss']
})
export class EnterpriseComponent implements OnInit {
  email: any;
  // emailEnterprise: FormGroup;
  country: string;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    public loadScript: LoadScriptService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('기업용 Trinka | 팀에게 적합한 고급 문법 검사기');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka 는 팀에게 유일한 글쓰기 지원 학술 기관, 언어 서비스 기업, 출판사, 컨텐츠 기업에게 가장 적합합니다.' });
    this.metaTagService.updateTag({ name: 'keywords', content: '문법 검사기, 문법 교정, 자동 문법 검사, 자동 철자 교정, 연구기관 학술적 글쓰기 지원, 출판사 학술적 글쓰기 지원, 언어 서비스 기업 학술적 글쓰기 지원' });
    this.metaTagService.updateTag({ property: 'og:title', content: '기업용 Trinka | 팀에게 적합한 고급 문법 검사기' });
    this.metaTagService.updateTag({ property: 'og:description', content: '지금 문의하고 합리적인 가격을 알아보세요.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/enterprise' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '기업용 Trinka | 팀에게 적합한 고급 문법 검사기' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka 는 팀에게 유일한 글쓰기 지원 학술 기관, 언어 서비스 기업, 출판사, 컨텐츠 기업에게 가장 적합합니다." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../assets/js/home_client_slider.js', function () { });
      AOS.init();
    }
    AOS.init();
  }
  
}
